<mbs-modal
  [isCustomModal]="true"
  [loading]="loading()"
  [showFooter]="true"
  [title]="'wizards:entityWizards.company.administratorsStep.createModal.title' | i18next">
  <ng-container
    modal-body
    [formGroup]="form">
    <!-- appendTo is 'body', not the usual '.modal-content': the wizard is itself a modal, so ng-select's
      document.querySelector would resolve '.modal-content' to the wizard's window and render the panel behind this one. -->
    <mbs-form-group>
      <mbs-select
        formControlName="accountType"
        [appendTo]="'body'"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [clearable]="false"
        [items]="accountTypes"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.accountType' | i18next"
        [placeholder]="'wizards:entityWizards.company.administratorsStep.createModal.accountTypePlaceholder' | i18next"
        [required]="true"
        [searchable]="false">
        <ng-template
          #mbsSelectOptionTmp
          let-item="item">
          <span class="d-block">{{ item.name }}</span>
          <span class="d-block text-sm text-muted">{{ item.description }}</span>
        </ng-template>
      </mbs-select>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-select
        formControlName="permissionsOption"
        [appendTo]="'body'"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [clearable]="false"
        [items]="permissionsOptions"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.permissions' | i18next"
        [placeholder]="'wizards:entityWizards.company.administratorsStep.createModal.permissionsPlaceholder' | i18next"
        [searchable]="false"
        (change)="permissionsOptionChangeHandler($event)"></mbs-select>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        autocomplete="off"
        formControlName="email"
        name="companyAdministratorEmail"
        [id]="'company-administrator-email'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.email' | i18next"></mbs-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        formControlName="password"
        name="companyAdministratorPassword"
        [appendButtons]="passwordButtons()"
        [autocomplete]="'new-password'"
        [container]="'body'"
        [errorTooltipTitle]="'shared:password-error-title' | i18next"
        [id]="'company-administrator-password'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.password' | i18next"
        [placement]="'left'"
        [showErrorsInTooltip]="true"
        [tooltipClass]="'tooltip-lg mr-1 tooltip-z-as-modal'"
        [trim]="false"
        [type]="passwordType()"
        (buttonClick)="passwordVisibilityClickHandler()">
        <ng-container appendLabel>
          <span
            class="ico ico-info-circle ml-2 cursor-help text-info"
            container="body"
            tooltipClass="tooltip-xl"
            [ngbTooltip]="passwordRulesTooltip"></span>
          <ng-template #passwordRulesTooltip>
            <ul class="text-start m-0 p-3">
              @for (rule of passwordRules(); track rule) {
                <li class="text-md ml-2 mb-1 pb-0">{{ rule }}</li>
              }
            </ul>
          </ng-template>
        </ng-container>
      </mbs-input>

      <mbs-button
        class="d-inline-block mt-2"
        [loading]="passwordGenerating()"
        (click)="generatePasswordClickHandler()">
        {{ 'wizards:entityWizards.company.administratorsStep.createModal.generatePassword' | i18next }}
      </mbs-button>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        formControlName="firstName"
        name="companyAdministratorFirstName"
        [id]="'company-administrator-first-name'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.firstName' | i18next"></mbs-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input
        formControlName="lastName"
        name="companyAdministratorLastName"
        [id]="'company-administrator-last-name'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.lastName' | i18next"></mbs-input>
    </mbs-form-group>

    <mbs-form-group class="mb-0">
      <mbs-checkbox
        formControlName="enabled"
        name="companyAdministratorEnabled"
        [id]="'company-administrator-enabled'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.enabled' | i18next"></mbs-checkbox>

      <mbs-checkbox
        formControlName="sendInstruction"
        name="companyAdministratorSendInstruction"
        [id]="'company-administrator-send-instruction'"
        [label]="'wizards:entityWizards.company.administratorsStep.createModal.sendInstruction' | i18next"></mbs-checkbox>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
